exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._24GK1Bj6OPmyIJ-k0qYOJ8,._13RBkiOVTngVKwrpqhSKzb{height:40px}html[dir] ._24GK1Bj6OPmyIJ-k0qYOJ8,html[dir] ._13RBkiOVTngVKwrpqhSKzb{margin:-12px 0}", ""]);
// Exports
exports.locals = {
	"nudgeFeedbackRibbon": "_24GK1Bj6OPmyIJ-k0qYOJ8",
	"spotlightFeedbackRibbon": "_13RBkiOVTngVKwrpqhSKzb"
};